import { createAppWrap } from '../../create_app_wrap';
import commonMixin from '../../mixins/_common';
import flashMessageMixin from '../../mixins/_flash_messages';
import chromeExtensionMixin from '../../mixins/_chrome_extension';
import modalYahooAuth from '../../components/_modal_yahoo_auth';
import templateSelecter from '../../components/_template_selecter';
import preview from './_preview_component';
import designEdit from './_design_edit_component';

const view = '[data-view="custom_page-new"]';
const init = () => {
    createAppWrap({
        el: view,
        data () {
            return {
                // 画面表示フラグ(isValidTokenで更新)
                show_disp: false,
                // 選択されたテンプレート
                template: {},
            };
        },
        mixins: [
            commonMixin,
            flashMessageMixin,
            chromeExtensionMixin,
        ],
        components: {
            // ヤフーAPIトークン認証チェックコンポーネント
            'modal-yahoo-auth': modalYahooAuth,
            // プレビューコンポーネント
            'preview': preview,
            // デザイン編集コンポーネント
            'design-edit': designEdit,
            // テンプレート選択コンポーネント
            'template-selecter': templateSelecter,
        },
        computed: {
            // テンプレート選択画面を表示するか否か
            isShowTemplateSelect: function () {
                const params = this.$_params();
                // パラメータ指定なし、templateが空の場合
                return (typeof params.id === 'undefined' && typeof params.page_key === 'undefined' && !Object.keys(this.template).length);
            },
        },
        mounted: function () {
            // 共通グローバルヘッダ非表示
            this.$_showGlobalHeader(false);
        },
        methods: {
            // プレビューを表示
            showPreview: function (template) {
                this.$refs.preview.show(template.title, template.data);
            },
            // テンプレートをセット
            setTemplate: function (template) {
                this.template = template;
                // スクロールをTOPへ
                window.scroll(0, 0);
            },
        }
    });
};

if (document.querySelector(view)) {
    init();
}